"use client"

import { useTheme } from "next-themes"
import { Toaster as SileoToaster } from "sileo"

export function Toaster() {
  const { theme = "system" } = useTheme()

  return <SileoToaster position="top-center" theme={theme as "light" | "dark" | "system"} />
}
